import { ContentBlocks } from "eddev/blocks"
import { defineView } from "eddev/views"

export default defineView("page", (props) => {
  return (
    <ContentBlocks blocks={props.page?.contentBlocks} />
  )
})
